import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { empAllowanceCreationValidation } from "core/Operations/ValidationSchema/payrollValidation";
import {
  useGetEmpAdditionsQuery,
  useUpdateEmpAdditionMutation,
} from "AppQuries/payroll/addition/emp-addition";

import EmpAllowanceForm from "Components/Form/EmpAllowanceForm";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { toast } from "core/Operations/toast";
const EditEmpAllowance = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();

  const { data: additiomData } = useGetEmpAdditionsQuery({
    companyCode: userData.companyCode,
    locationCode: userData.selectedLocationCode,
    allowanceCode: code,
  });
  const {
    mutate: editEmpAllowance,
    isPending,
    isError,
    error,
  } = useUpdateEmpAdditionMutation();

  const methods = useForm({
    resolver: yupResolver(empAllowanceCreationValidation),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    setValue,
    formState: { errors },
  } = methods;

  const onSubmit = (payload) => {
    payload.modifyUser = userData.userName;
    payload.modifyDate = getCurrentFormattedDate();
    editEmpAllowance(payload, {
      onSuccess: (data) => {
        if (data[0]?.response === true) {
          toast.success("Employee Allowance Added Successfully.");
          setTimeout(() => {
            navigate(`${all_routes.emp_allowance}`);
          }, 1000);
        } else {
          toast.warning(data[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };
  useEffect(() => {
    if (Array.isArray(additiomData)) {
      Object.keys(additiomData[0]).forEach((key) => {
        setValue(key, additiomData[0][key]);
      });
    }
  }, [additiomData]);

  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Edit Employee Addition</h4>
                    <h6>Edit Employee Addition details </h6>
                  </div>
                </div>

                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="back-tooltip">Back</Tooltip>}
                  >
                    <Link
                      className="btn btn-secondary"
                      to={`${all_routes.emp_allowance}`}
                    >
                      <i className="fa fa-reply me-2"></i>
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Save Employee Addition
                      </Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Edit Employee Addition</h4>
                    </div>
                    <div className="card-body">
                      <EmpAllowanceForm mode="E" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default EditEmpAllowance;
